<template>
    <div>
        <ul>
            <li
                v-for="option in options"
                :key="option.id"
            >
                <CategoryFilterOption
                    :active="attributeIds.includes(option.id)"
                    :image="option.image"
                    @click="handleInputChange(option.id)"
                >
                    {{ option.name }}
                </CategoryFilterOption>
            </li>
        </ul>
    </div>
</template>

<script>
import Select from '@/components/Select';
import CategoryFilterOption from '@/components/CategoryFilterOption.vue';

export default {

    components: {
        CategoryFilterOption,
        Select,
    },

    props: {
        options: {
            type: Array,
            required: true,
        },
        attributeIds: {
            type: Array,
            default: () => [],
        },
    },

    methods: {
        handleInputChange(optionId) {
            const newIds = [...this.attributeIds];
            const index = newIds.indexOf(optionId);
            
            if (index > -1) {
                newIds.splice(index, 1);
            } else {
                newIds.push(optionId);
            }
            
            this.$emit('change', newIds);
        },
    },

};
</script>

<style lang="scss" scoped>
select {
    @apply bg-white border border-primary rounded-full px-4 h-10 flex items-center text-sm font-semibold text-primary;
    border-width: 2px;
    -webkit-appearance: none;
}
</style>
